export default "__VITE_ASSET__C4vsB35y__"